const HorizontalLine = {
    id: 'HorizontalLine',
    afterDraw: function(chart) {
        if (typeof chart.options.linearGradientThreshold != 'undefined') {
            var lineAt = chart.options.linearGradientThreshold;
            const { ctx } = chart;
            var xAxe = chart.scales.x;
            var yAxe = chart.scales.y;

            ctx.strokeStyle = '#808080';
            ctx.beginPath();
            lineAt = (lineAt - yAxe.min) * (100 / yAxe.max);
            lineAt = ((100 - lineAt) / 100) * yAxe.height + yAxe.top;
            ctx.moveTo(xAxe.left, lineAt);
            ctx.lineTo(xAxe.right, lineAt);
            ctx.stroke();
            ctx.restore();
        }
    }
};

export default HorizontalLine;
